import { motion } from "framer-motion";
import { useEffect } from "react"; 
import {
  FaChartLine,
  // FaDollarSign,
  FaFileInvoiceDollar,
  FaCogs,
  FaProjectDiagram,
} from "react-icons/fa";

const services = [
  // {
  //   icon: FaDollarSign,
  //   titleAr: "دراسة الجدوى",
  //   titleEn: "Feasibility Study",
  //   descAr: "تحليل مالي وفني شامل لاتخاذ قرارات استثمارية دقيقة",
  //   descEn: "Comprehensive financial and technical analysis for smart decisions.",
  // },
  {
    icon: FaChartLine,
    titleAr: "تحليل المنافسين",
    titleEn: "Competitor Analysis",
    descAr: "فهم السوق والمنافسين لتحديد فرص النمو",
    descEn: "Understanding competitors to identify growth opportunities.",
  },
  {
    icon: FaFileInvoiceDollar,
    titleAr: "حلول التمويل",
    titleEn: "Financing Solutions",
    descAr: "مساعدتك في اختيار أفضل خيارات التمويل",
    descEn: "Helping you choose the best financing options.",
  },
  {
    icon: FaProjectDiagram,
    titleAr: "إعداد خطط استراتيجية",
    titleEn: "Strategic Planning",
    descAr: "بناء خطط واضحة لتحقيق أهدافك",
    descEn: "Building clear strategies to achieve your goals.",
  },
  {
    icon: FaFileInvoiceDollar,
    titleAr: "إعداد موازنات",
    titleEn: "Budget Planning",
    descAr: "تخطيط مالي دقيق للمشروع",
    descEn: "Accurate financial planning for your project.",
  },
  {
    icon: FaCogs,
    titleAr: "خطوط إنتاج",
    titleEn: "Production Lines",
    descAr: "تصميم وتشغيل خطوط إنتاج فعالة",
    descEn: "Designing efficient production lines.",
  },
];

export default function ServicesSection({ language = "en" }) {
  useEffect(() => {
  const handleMove = (e) => {
    const x = e.clientX / window.innerWidth;
    const y = e.clientY / window.innerHeight;

    document.querySelectorAll(".blob").forEach((el, i) => {
      el.style.transform = `translate(${x * 40}px, ${y * 40}px)`;
    });
  };

  window.addEventListener("mousemove", handleMove);
  return () => window.removeEventListener("mousemove", handleMove);
}, []);

  return (




    
    <section className="services-section">

  <div className="bg-wrapper">
    <div className="gradient-layer"></div>
    <div className="blob blob1"></div>
    <div className="blob blob2"></div>
    <div className="blob blob3"></div>
  </div>
      <h2 className="services-main-title">
        {language === "ar" ? "ماذا نقدم" : "What We Offer"}
      </h2>

      <div className="services-grid">
        {services.map((s, i) => {
          const Icon = s.icon;

          return (
            <motion.div
              key={i}
              className="service-card glass"
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              whileHover={{ scale: 1.05 }}
            >

              <div className="icon-glow">
                <Icon />
              </div>

              <h3>
                {language === "ar" ? s.titleAr : s.titleEn}
              </h3>

              <p>
                {language === "ar" ? s.descAr : s.descEn}
              </p>

              <div className="card-shine"></div>

            </motion.div>
          );
        })}
      </div>

    </section>
  );
}
